import {Component, OnInit} from '@angular/core';
import {ExecutiveService} from '../../shared/services/executive.service';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StorageService} from '../../shared/services/storage.service';

@Component({
  selector: 'app-executives',
  templateUrl: './executives.component.html',
  styleUrls: ['./executives.component.scss']
})

export class ExecutivesComponent implements OnInit {
  executives = [];
  searchForm: FormGroup;
  showSearch = false;
  submitted: any = false;
  submitting: any = false;
  updatePasswordForm: FormGroup;
  inputTypePassword = 'password';
  id: any;
  user: any;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(private executiveService: ExecutiveService,
              private router: Router,
              private fb: FormBuilder,
              public modalService: NgbModal) {
  }

  ngOnInit() {
    this.user = StorageService.getItem('self');
    if (this.user.user_type !== 'SUPER_ADMIN' && this.user.user_type !== 'ADMIN') {
      this.router.navigateByUrl('');
    }
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'name': [''],
      'username': [''],
      'email': [''],
      'contact': [''],
    });
    this.updatePasswordForm = this.fb.group({
      'password': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.per_page = this.pagination.perpage;
    this.submitting = true;
    this.executives = [];
    this.executiveService.get(params).subscribe(data => {
      if (data && data['data'].length > 0) {
        this.executives = data['data'];
        this.pagination = {
          page: data.current_page,
          total: data.total,
          perpage: data.per_page,
          pages: data.last_page,
        };
      } else {
        this.executives = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  search() {
    let params = {
      'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
      'username': (this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
      'email': (this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : '',
      'contact': (this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : ''
    };
    this.get(params);
  }

  navigateTo(url) {
    this.router.navigateByUrl(url);
  }

  getExecutiveConversation(id) {
    const url = 'conversations/' + id;
    this.router.navigateByUrl(url);
  }

  edit(id) {
    const url = 'executive/' + id + '/edit';
    this.router.navigateByUrl(url);
  }

  updatePasswordModal(content, id) {
    this.id = id;
    this.modalService.open(content, {'size': 'sm'});
  }

  updatePassword() {
    this.submitted = true;
    if (!this.updatePasswordForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'password': (this.updatePasswordForm.value && this.updatePasswordForm.value.password) ? this.updatePasswordForm.value.password : ''
      };
      this.submitting = true;
      this.executiveService.updatePassword(this.id, params).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
        this.id = undefined;
        this.updatePasswordForm.patchValue({
          'password': '',
        });
        this.modalService.dismissAll('');
      }, error => {
        this.submitting = false;
        this.submitted = false;
        this.id = undefined;
      });
    }
  }

  updateStatus(status, data) {
    this.submitted = true;
    if (this.submitted) {
      const params = {
        'status': status
      };
      this.submitting = true;
      this.executiveService.updateStatus(data.id, params).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
        this.id = undefined;
        this.modalService.dismissAll('');
        this.get();
      }, error => {
        this.submitting = false;
        this.submitted = false;
        this.id = undefined;
      });
    }
  }

  onPageChange(page) {
    this.pagination.page = page;
    let params = {
      'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
      'username': (this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
      'email': (this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : '',
      'contact': (this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : ''
    };
    this.get(params);
  }
}
